import {MODE_TYPE, VIEW_TYPE} from "@/components/EventGrid/constants";
import {fetchDates, fetchDefaultEvents, fetchGroupedEvents} from "@/store/api/api";
import {timestampToText} from "@/store/helpers/event-timestamp";

/**
 * Имена экшенов для запроса событий
 * где ключ - тип вида списка событий
 */
const actionMap = {
    [VIEW_TYPE.DEFAULT]: 'fetchDefaultEvents',
    [VIEW_TYPE.GROUPED]: 'fetchGroupedEvents'
}

export default {
    namespaced: true,
    state: {
        dates: [],                      // Даты с событиями
        events: [],                     // Все события выбранной даты
        modeType: MODE_TYPE.RADIO,      // Тип выбора событий (по умолчанию RADIO) Устанавливается из конфига
        currentDate: null,              // Выбранная дата
        currentEvents: [],              // Выбранные события
    },
    getters: {
        getAllDates: (state) => state.dates,
        getAllEvents: (state) => state.events,
        isDateAvailable: (state) => ({epochTimestamp}) => state.dates.includes(epochTimestamp),

        getCurrentDate: (state) => state.currentDate ? new Date(state.currentDate * 1000) : null,
        getModeType: (state) => state.modeType,
        getCurrentEvents: (state) => state.currentEvents,
        getCurrentEventById: (state) => ({id}) => state.currentEvents.find(event => event.id === parseInt(id)),
        getCurrentEventsDatetimeTitles: (state) =>
            state.currentEvents
                .map(event => timestampToText(event.timestamp))
                .join(', '),
        isNoCurrentEvents: (state) => !state.currentEvents.length,
        isEventActive: (state) => ({id}) =>
            !!state.currentEvents.find(event => event.id === id),
        /**
         * Считает общую сумму для указанного кол-ва занятых мест (полных и льготных)
         */
        getTotalPrice: (state) => ({eventId, fullPlaces, discountPlaces}) => {
            const event = state.currentEvents.find(event => event.id === eventId)
            if (!event) return 0;
            return (event.price.norm || 0) * fullPlaces
                + (event.price.disc || 0) * discountPlaces;
        }
    },
    mutations: {
        setDates(state, payload) {
            state.dates = payload;
        },
        setCurrentDate(state, payload) {
            state.currentDate = payload;
        },
        clearCurrentDate(state) {
            state.currentDate = null;
        },
        setEvents(state, payload) {
            state.events = payload;

            // state.event
        },
        addCurrentEvent(state, event) {
            if (event) {
                state.currentEvents.push(event);
            }
        },
        removeCurrentEvent(state, {id}) {
            state.currentEvents = state.currentEvents.filter(event => event.id !== id);
        },
        clearEvents(state) {
            state.currentEvents = [];
        },
        clearAvailableEvents(state) {
            state.events = [];
        },
        setMode(state, {type}) {
            if (Object.values(MODE_TYPE).includes(type)) {
                state.modeType = type;
            }
        },
    },
    actions: {
        async fetchDates({commit}, options) {
            const dates = await fetchDates(options);
            commit('setDates', dates);
        },
        async fetchDefaultEvents({commit}, options) {
            const events = await fetchDefaultEvents(options);
            commit('setEvents', events);
        },
        async fetchGroupedEvents({commit}, options) {
            const events = await fetchGroupedEvents(options);
            commit('setEvents', events);
        },
        async fetchEvents({dispatch}, {epochTimestamp, viewType}) {
            const options = {epochTimestamp};
            dispatch(actionMap[viewType], options);

            console.log(`[event] Запрос событий...\nМетод:${actionMap[viewType]}\nTimestamp:${epochTimestamp}`);
        },
        clearEvents({commit, dispatch}) {
            commit('clearEvents');
            commit('clearCurrentDate');
            dispatch('clearEventDependencies');
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearEventDependencies({dispatch}) {
            dispatch('places/clearPlaces', null, {root: true});
        },
        /**
         * Переключает активность события
         * (добавляет/удаляет из массива выбранных событий)
         * + сайд-эффекты (которые возможно стоит вынести)
         */
        toggleEvent({commit, getters, dispatch}, event) {
            if (getters.isEventActive(event)) {
                // Убрать из выбранных событий
                commit('removeCurrentEvent', event);
                // Удалить объект подсчета выбранных мест для этого события
                commit('places/removePlacesInfo', {eventId: event.id}, {root: true});
            } else {
                if (getters.getModeType === MODE_TYPE.RADIO) {
                    commit('clearEvents');
                    commit('places/clearPlaces', null, {root: true});
                }
                // Добавить в выбранные события
                commit('addCurrentEvent', event);
                // Установить персону из события
                commit('person/setCurrentPerson', event.person_id, {root: true});
                // Создать объект подсчета выбранных мест для этого события
                commit('places/addPlacesInfo', {eventId: event.id}, {root: true});
            }

            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
    }
}
